import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DownloadMappingChannelStoreEffects } from './effects';
import { downloadMappingChannelReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      'downloadMappingChannel',
      downloadMappingChannelReducer,
    ),
    EffectsModule.forFeature([DownloadMappingChannelStoreEffects]),
  ],
})
export class DownloadMappingChannelStoreModule {}
